import React from 'react'

import {
  func, number, string, bool, object,
} from 'prop-types'

import ModelActions from './ModelActions'
import ShortModelInfo from './ShortModelInfo'

function ModelInfoFooter({
  title,
  id,
  modelRating = 0,
  modelRatingCount = 0,
  commentCount = 0,
  likeCount = 0,
  viewCount = 0,
  modelUrl,
  handleWishlist,
  isWishlistAvailable,
  isOnWishlist,
  isWishListActionLoading = false,
  handleCart,
  isCartAvailable,
  isOnCart,
  isCartActionLoading = false,
  fullScreenGallery,
  hideInfo,
  isPurchased = false,
  itemAttributes,
}) {
  return (
    <div className="cgt-model-gallery-new__footer">
      {!hideInfo && (
        <ShortModelInfo
          title={title}
          modelRating={modelRating}
          modelRatingCount={modelRatingCount}
          commentCount={commentCount}
          likeCount={likeCount}
          viewCount={viewCount}
          fullScreenGallery={fullScreenGallery}
        />
      )}
      <ModelActions
        id={id}
        modelUrl={modelUrl}
        isOnWishlist={isOnWishlist}
        handleWishlist={handleWishlist}
        isWishlistAvailable={isWishlistAvailable}
        isWishListActionLoading={isWishListActionLoading}
        isOnCart={isOnCart}
        handleCart={handleCart}
        isCartAvailable={isCartAvailable}
        isCartActionLoading={isCartActionLoading}
        fullScreenGallery={fullScreenGallery}
        expandButtons={hideInfo}
        isPurchased={isPurchased}
        itemAttributes={itemAttributes}
      />
    </div>
  )
}

ModelInfoFooter.propTypes = {
  title: string.isRequired,
  id: string.isRequired,
  likeCount: number,
  modelRating: number,
  modelRatingCount: number,
  commentCount: number,
  viewCount: number,
  modelUrl: string.isRequired,
  isOnWishlist: bool.isRequired,
  handleWishlist: func.isRequired,
  isWishlistAvailable: bool.isRequired,
  isWishListActionLoading: bool,
  isCartActionLoading: bool,
  handleCart: func.isRequired,
  isCartAvailable: bool.isRequired,
  isOnCart: bool.isRequired,
  fullScreenGallery: bool.isRequired,
  hideInfo: bool.isRequired,
  isPurchased: bool,
  itemAttributes: object.isRequired,
}

export default ModelInfoFooter
